import { lazy } from "common/load/componentUtils";

import { useDrawer } from "client/common/hooks/stackables";

const ControlledSubstanceGuidanceDrawer = lazy(
  () => import("../components/stackables/ControlledSubstanceGuidanceDrawer"),
);

export const useControlledSubstanceGuidanceDrawer = () => {
  const { open } = useDrawer();
  return {
    open: () => open(ControlledSubstanceGuidanceDrawer),
  };
};
